'use client';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import toast from "react-hot-toast";

interface SubscriptionData {
    email: string;
    name?: string;
}

const useHandleSubscription = () => {
    const base_url = process.env.NEXT_PUBLIC_BASE_URL;
    const newsletterSubscriptionSchema = yup.object({
        email: yup.string().email('Invalid email address').required("Email address is required"),
        name: yup.string(),
    });
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm({
        resolver: yupResolver(newsletterSubscriptionSchema),
    });

    const handleSubscription = async (data: SubscriptionData) => {
        try {
            const response = await axios.post(`${base_url}/api/blog/subscribe`, {
                email: data?.email,
            });
            toast.success(response?.data?.message);
            reset();
        } catch (error: any) {
            toast.error(error?.response?.data?.message);
            console.log("Subscription error:", error);
        }
    };

    
    
  return {
    register,
    errors,
    handleSubmit,
    isSubmitting,
    handleSubscription,
  }
}

export default useHandleSubscription;